import { useState, useRef, useEffect } from 'react';
import { VisxText } from '@/components/VisxText';
import { useTheme } from '@simplywallst/ui-core';

interface Props {
  x: number;
  y: number | string;
  label: string;
  value: string;
  bound: number;
  height: number;
}

const Label = ({ x, y, label, value, bound, height }: Props) => {
  const theme = useTheme();
  const containerRef = useRef<SVGSVGElement>(null);
  const [labelRight, setLabelRight] = useState(false);
  useEffect(() => {
    const { current: container } = containerRef;
    if (container !== null && bound > 0) {
      const width = container.getBBox().width + 32;
      const nextLabelRight = x < width / bound;
      if (labelRight !== nextLabelRight) {
        setLabelRight(nextLabelRight);
      }
    }
  }, [x, bound, labelRight]);
  return (
    <svg x={0} y={y} height={height} width="100%" ref={containerRef}>
      <VisxText
        data-cy-id={`chart-DCF-title-${label}`}
        verticalAnchor="end"
        textAnchor={labelRight ? 'start' : 'end'}
        y={height / 2 - 8}
        x={`${x * 100}%`}
        dx={labelRight ? 14 : -14}
        typography="smallStrong"
        fill={
          theme.appTheme === 'dark' ? theme.color.white : theme.color.spaceGray
        }
      >
        {label}
      </VisxText>
      {value !== '' && (
        <VisxText
          data-cy-id={`chart-DCF-value-${label}`}
          y={height / 2 + 4}
          x={`${x * 100}%`}
          dx={labelRight ? 13.5 : -13.5}
          verticalAnchor="start"
          textAnchor={labelRight ? 'start' : 'end'}
          typography="xLargeStrong"
          fill={
            theme.appTheme === 'dark'
              ? theme.color.white
              : theme.color.spaceGray
          }
        >
          {value}
        </VisxText>
      )}
    </svg>
  );
};

export default Label;
